import React from 'react'
import styled from '@emotion/styled'
import * as constants from 'view/styles/constants'
import * as mixins from 'view/styles/mixins'
import { Tab } from './Tab'
import { Translation, Locale } from 'locale'

export interface TabsProps {
  selectedTab: Translation
  onChangeTab: (tab: Translation) => void
  tabs: Translation[]
  dataTestId?: string
}

const TabsContainer = styled.div`
  ${mixins.flexCenterContentCrossAxis};
  height: 34px;
  padding: 5px 30px 0 30px;
  padding-top: 2px;
  background-color: ${constants.CORE_PRIMARY_1};
`

export class Tabs extends React.Component<TabsProps> {
  render() {
    const { onChangeTab, selectedTab, tabs, dataTestId } = this.props
    return (
      <TabsContainer>
        {tabs.map(tab => (
          <Tab
            dataTestId={`${dataTestId}-Tab`}
            key={tab}
            label={Locale.translate(tab)}
            selected={tab === selectedTab}
            onClick={() => onChangeTab(tab)}
          />
        ))}
      </TabsContainer>
    )
  }
}
